/* dashboard: перевод строк интерфейса. Ключ — русская строка ровно как в коде.
   Окна «Дашборд», «Виджеты», «Начало работы», «Отчёты» и их демо-данные. */
const d: Record<string, string> = {
  // ── навигация / общие ──
  "Дашборд": "Dashboard",
  "Входящие": "Inbox",
  "Контакты": "Contacts",
  "Каналы": "Channels",
  "AI-агенты": "AI agents",
  "Рассылки": "Broadcasts",
  "Рабочие процессы": "Workflows",
  "Отчеты": "Reports",
  "Настройки": "Settings",
  "Жизненный цикл": "Lifecycle",
  "Начало работы": "Getting started",
  "Демо-данные": "Demo data",
  "Обновлено": "Updated",
  "Обновляем": "Refreshing",
  "Обновить": "Refresh",
  "только что": "just now",
  "прямо сейчас": "right now",
  "сегодня в {time}": "today at {time}",
  "Раздел «{label}» в демо не открывается": "The \"{label}\" section does not open in the demo",
  "Пробный период {plan} закончится {ends} — через {days} дней. Обновите тариф, чтобы не потерять доступ.":
    "Your {plan} trial ends on {ends} — in {days} days. Upgrade your plan to keep access.",
  "Пробный период Growth Plan закончится 3 ноября 2026 — через 6 дней. Обновите тариф, чтобы не потерять доступ.":
    "Your Growth Plan trial ends on 3 November 2026 — in 6 days. Upgrade your plan to keep access.",
  "3 ноября 2026": "3 November 2026",
  "Чеклист онбординга": "Onboarding checklist",
  "Демо-режим: смена тарифа здесь недоступна": "Demo mode: changing the plan is not available here",
  "Обновить тариф": "Upgrade plan",
  "В": "V",
  "Часовой пояс — {tz}": "Time zone — {tz}",
  "Подключить канал": "Connect a channel",
  "Отмена": "Cancel",
  "Почта": "Email",
  "Звонки": "Calls",
  "Канал": "Channel",
  "Статус": "Status",
  "Команда": "Team",

  // ── дашборд ──
  "Данные обновлены — счётчики пересчитаны": "Data refreshed — counters recalculated",
  "Демо-данные включены: 35 контактов на четырёх этапах": "Demo data on: 35 contacts across four stages",
  "Демо-данные выключены — снова пустое рабочее пространство": "Demo data off — the workspace is empty again",
  "рабочее пространство → дашборд": "workspace → dashboard",
  "Каналы ещё не подключены": "No channels connected yet",
  "У вас нет подключённых каналов": "You have no connected channels",
  "Можно подключить все аккаунты переписки в одном месте — это и есть каналы. Подключите канал, чтобы диалоги попали во входящие и дашборд начал считать контакты.":
    "Connect all your messaging accounts in one place — these are channels. Connect a channel so conversations land in the inbox and the dashboard starts counting contacts.",
  "Анна Ковалёва": "Anna Kovaleva",
  "Здравствуйте! Подскажите цену": "Hello! Could you tell me the price?",
  "Игорь Дёмин": "Igor Demin",
  "Счёт получил, оплачу завтра": "Got the invoice, will pay tomorrow",
  "Марина Гусева": "Marina Guseva",
  "Нужна консультация по тарифу": "I need advice on a plan",
  "Настроить жизненный цикл": "Configure lifecycle",
  "Нажмите на этап, чтобы отфильтровать контакты ниже.": "Click a stage to filter the contacts below.",
  "Поля контактов": "Contact fields",
  "Настроить поля контактов": "Configure contact fields",
  "Пока нет контактов": "No contacts yet",
  "На этапе «{stage}» пусто": "The \"{stage}\" stage is empty",
  "Здесь пока пусто": "Nothing here yet",
  "Подключите канал — и диалоги клиентов появятся во входящих и на дашборде.": "Connect a channel — customer conversations will appear in the inbox and on the dashboard.",
  "Снимите фильтр по этапу или выберите другую вкладку.": "Remove the stage filter or pick another tab.",
  "В этой вкладке нет контактов — попробуйте другую.": "No contacts in this tab — try another one.",
  "не назначен": "unassigned",
  "Участники команды": "Team members",
  "Фильтр участников: {label}": "Member filter: {label}",
  "Фильтр участников по статусу": "Filter members by status",
  "Никого нет по этому статусу": "Nobody matches this status",
  "Показать всех": "Show all",
  "назначено": "assigned",
  "контактов": "contact|contacts",
  "{n} из {total} участников": "{n} of {total} members",
  "1 участник": "1 member",
  "Настройки команды": "Team settings",
  "Демо-режим: цифры и списки меняются только на этой странице и не сохраняются после перезагрузки.":
    "Demo mode: numbers and lists change only on this page and are not saved after reload.",
  "Новый лид": "New lead",
  "Горячий лид": "Hot lead",
  "Оплата": "Payment",
  "Клиент": "Customer",
  "В работе": "In progress",
  "Ждут ответа": "Awaiting reply",
  "Просрочено": "Overdue",
  "Открытые": "Open",
  "Назначенные": "Assigned",
  "Неназначенные": "Unassigned",
  "АК": "AK",
  "Виктор Ярутов": "Viktor Yarutov",
  "ВЯ": "VY",
  "ИД": "ID",
  "МГ": "MG",
  "Павел Ким": "Pavel Kim",
  "ПК": "PK",
  "Ольга Смирнова": "Olga Smirnova",
  "ОС": "OS",
  "Алина Гусева": "Alina Guseva",
  "АГ": "AG",
  "Сергей Лебедев": "Sergey Lebedev",
  "СЛ": "SL",
  "2 мин назад": "2 min ago",
  "14 мин назад": "14 min ago",
  "26 мин назад": "26 min ago",
  "41 мин назад": "41 min ago",
  "1 ч назад": "1 h ago",
  "2 ч назад": "2 h ago",
  "Владелец": "Owner",
  "Менеджер": "Manager",
  "Агент": "Agent",
  "Вчера в 22:45": "Yesterday at 22:45",
  "Сегодня в 09:12": "Today at 09:12",
  "Вчера в 18:04": "Yesterday at 18:04",
  "Все статусы": "All statuses",
  "Онлайн": "Online",
  "Не в сети": "Offline",
  "Счётчики этапов": "Stage counters",
  "Число и доля контактов на каждом этапе жизненного цикла — видно, где скапливаются лиды.":
    "Number and share of contacts at each lifecycle stage — see where leads pile up.",
  "Вкладки контактов": "Contact tabs",
  "Открытые, назначенные и неназначенные: сразу понятно, кто ждёт ответа и на кого ничего не закреплено.":
    "Open, assigned and unassigned: instantly see who is awaiting a reply and who has nothing assigned.",
  "Нагрузка команды": "Team workload",
  "Сколько контактов закреплено за каждым участником и когда он был в сети.": "How many contacts each member has and when they were last online.",

  // ── виджеты ──
  "{name}: код установлен — виджет появится на сайте через минуту": "{name}: code installed — the widget will appear on your site in a minute",
  "настройки → виджеты": "settings → widgets",
  "Установлено": "Installed",
  "Создать виджет": "Create widget",
  "Каталог виджетов": "Widget catalogue",
  "Доступы": "Access",
  "Код виджета и ключи видит только администратор. Продавцы получают диалоги, а не токены.":
    "Only admins can see widget code and keys. Sales reps get conversations, not tokens.",
  "Поиск по виджетам": "Search widgets",
  "Найти виджет: WhatsApp, соцсети, заявка…": "Find a widget: WhatsApp, social, lead form…",
  "{n} виджетов ждут подключения канала.": "{n} widgets are waiting for a channel.",
  "На сайте": "On site",
  "Готов к установке": "Ready to install",
  "Нужен канал: {channel}": "Channel required: {channel}",
  "Код": "Code",
  "Установить": "Install",
  "Подключить": "Connect",
  "Виджет не найден. Попробуйте другое название.": "Widget not found. Try a different name.",
  "Превью": "Preview",
  "Свернуть превью чата": "Collapse chat preview",
  "Сообщение…": "Message…",
  "Открыть превью виджета": "Open widget preview",
  "Позиция": "Position",
  "Слева": "Left",
  "Справа": "Right",
  "Приветствие": "Greeting",
  "Код для вставки": "Embed code",
  "Сначала канал": "Channel first",
  "Превью настоящее: двигайте позицию и текст — так виджет и будет выглядеть на сайте.":
    "The preview is live: change the position and text — this is how the widget will look on your site.",
  "Этот виджет пока не во что писать — подключите канал, и превью оживёт.": "This widget has nowhere to send messages yet — connect a channel and the preview will come alive.",
  "Демо-режим: установка имитируется в макете, код не публикуется и сайт не затрагивает.":
    "Demo mode: installation is simulated in the mockup; no code is published and your site is not affected.",
  "Закрыть окно установки": "Close install dialog",
  "Код для сайта": "Code for your site",
  "Установить «{name}»": "Install \"{name}\"",
  "Скопируйте код кнопкой ниже": "Copy the code with the button below",
  "Вставьте его перед закрывающим тегом </body> на сайте": "Paste it before the closing </body> tag on your site",
  "Обновите страницу — кнопка появится в правом нижнем углу": "Reload the page — the button will appear in the bottom-right corner",
  "Скопировано": "Copied",
  "Копировать": "Copy",
  "Позиция: {pos} · приветствие: «{greeting}»": "Position: {pos} · greeting: \"{greeting}\"",
  "справа": "right",
  "слева": "left",
  "Устанавливаем…": "Installing…",
  "Отметить как установленный": "Mark as installed",
  "Все виджеты": "All widgets",
  "Мессенджеры": "Messengers",
  "Соцсети": "Social",
  "Универсальные": "Universal",
  "Мультиканальный виджет": "Multichannel widget",
  "Клиент сам выбирает, куда писать: WhatsApp, Telegram или на почту — всё попадает в Hub.": "The customer picks where to write: WhatsApp, Telegram or email — everything lands in Hub.",
  "Популярный": "Popular",
  "Здравствуйте! Куда вам удобнее написать?": "Hello! Where would you prefer to write?",
  "Виджет WhatsApp": "WhatsApp widget",
  "Кнопка на сайте открывает чат с номером компании в WhatsApp — без копирования номера.": "A button on your site opens a WhatsApp chat with the company number — no copying numbers.",
  "Здравствуйте! Пишите в WhatsApp — ответим в течение 15 минут.": "Hello! Message us on WhatsApp — we reply within 15 minutes.",
  "Узнать цену": "Get a price",
  "Доставка": "Delivery",
  "Гарантия": "Warranty",
  "Виджет Telegram": "Telegram widget",
  "Клиент попадает в бота компании одним нажатием и сразу видит историю переписки.": "The customer reaches the company bot in one tap and sees the chat history right away.",
  "Здравствуйте! Открываю Telegram — бот уже ждёт ваш вопрос.": "Hello! Opening Telegram — the bot is ready for your question.",
  "Оформить заказ": "Place an order",
  "Статус заказа": "Order status",
  "Помощь": "Help",
  "Виджет Facebook": "Facebook widget",
  "Сообщения со страницы Facebook в том же окне, что и остальные диалоги.": "Messages from your Facebook page in the same window as all other conversations.",
  "Здравствуйте! Напишите нам в Messenger — ответим от лица компании.": "Hello! Write to us on Messenger — we reply on behalf of the company.",
  "Написать в Messenger": "Write on Messenger",
  "Каталог": "Catalogue",
  "Виджет Instagram": "Instagram widget",
  "Диалоги из Direct прямо с сайта: клиенту не нужно искать аккаунт вручную.": "Direct conversations straight from your site: the customer does not have to find your account.",
  "Здравствуйте! Продолжим в Direct — там удобнее смотреть фото.": "Hello! Let's continue in Direct — photos are easier to view there.",
  "Написать в Direct": "Write in Direct",
  "Новинки": "New arrivals",
  "Размеры": "Sizes",
  "Виджет TikTok": "TikTok widget",
  "Сообщения из TikTok и заявки по видео — в общей ленте диалогов.": "TikTok messages and video enquiries in the shared conversation feed.",
  "Новое": "New",
  "Здравствуйте! Отвечаем в TikTok — пришлём ссылку на товар из видео.": "Hello! We reply on TikTok — we'll send a link to the product from the video.",
  "Товар из видео": "Product from the video",
  "Наличие": "Availability",
  "Цена": "Price",
  "Виджет Viber": "Viber widget",
  "Официальный аккаунт Viber с рассылками и поддержкой клиентов.": "Official Viber account with broadcasts and customer support.",
  "Здравствуйте! Продолжим в Viber — там же придут уведомления о заказе.": "Hello! Let's continue in Viber — order notifications will arrive there too.",
  "Написать в Viber": "Write on Viber",
  "Заказ": "Order",
  "Виджет LINE": "LINE widget",
  "Кнопка LINE Messenger для клиентов из Азии и международных команд.": "A LINE Messenger button for customers in Asia and international teams.",
  "Виджет почты": "Email widget",
  "Форма «напишите нам» превращает письмо в диалог с историей и вложениями.": "A \"write to us\" form turns an email into a conversation with history and attachments.",
  "Оставьте почту — ответим письмом и продолжим диалог в Hub.": "Leave your email — we'll reply by mail and continue the conversation in Hub.",
  "Оставить почту": "Leave email",
  "Прайс-лист": "Price list",
  "Договор": "Contract",
  "Обратный звонок": "Callback",
  "Клиент оставляет номер — звонок падает в ленту с записью разговора.": "The customer leaves a number — the call lands in the feed with a recording.",
  "Быстрый старт": "Quick start",
  "Оставьте номер — перезвоним в течение рабочего дня.": "Leave your number — we'll call back within the business day.",
  "Перезвоните мне": "Call me back",
  "Удобное время": "Convenient time",
  "Отдел продаж": "Sales department",
  "Виджет заявки": "Lead form widget",
  "Короткая форма с именем и задачей — заявка сразу становится диалогом.": "A short form with a name and a task — the request becomes a conversation right away.",
  "Расскажите задачу — подберём решение и ответим в рабочее время.": "Describe your task — we'll find a solution and reply during business hours.",
  "Оставить заявку": "Submit a request",
  "Нужна консультация": "Need advice",
  "Смета": "Estimate",

  // ── начало работы ──
  "коллега": "colleague",
  "Шаг «{step}» отмечен выполненным": "Step \"{step}\" marked as done",
  "Этот шаг засчитан автоматически — он уже выполнен в рабочем пространстве": "This step was counted automatically — it is already done in the workspace",
  "Шаг снова в работе — прогресс пересчитался": "Step is back in progress — progress recalculated",
  "рабочее пространство → начало работы": "workspace → getting started",
  "Чеклист: {done} из {total}": "Checklist: {done} of {total}",
  "Привет, {name}! Давайте начнём.": "Hi, {name}! Let's get started.",
  "Все четыре шага пройдены — входящие, воронка и ассистент готовы к работе.": "All four steps done — inbox, pipeline and assistant are ready to go.",
  "Четыре шага, чтобы входящие заработали на всю команду.": "Four steps to get the inbox working for the whole team.",
  "{done} из {total}": "{done} of {total}",
  "Выполнено": "Done",
  "Шаг «{step}» отложен — вернётесь к нему позже": "Step \"{step}\" postponed — come back to it later",
  "Позже": "Later",
  "Отменить": "Undo",
  "Выполнено: {done} из {total}": "Done: {done} of {total}",
  "Прогресс сброшен — чеклист снова с начала": "Progress reset — the checklist starts over",
  "Сбросить прогресс": "Reset progress",
  "Ресурсы": "Resources",
  "Подсказки и помощь, если что-то не получается.": "Tips and help if something does not work.",
  "«{label}» появится позже — пока пишите через «Идея / Проблема» внизу экрана": "\"{label}\" is coming later — for now use \"Idea / issue\" at the bottom of the screen",
  "Отметки шагов сохраняются в вашем профиле; часть шагов засчитывается сама, когда они выполнены в пространстве.":
    "Step marks are saved in your profile; some steps are counted automatically once done in the workspace.",
  "Подключите каналы, чтобы объединить переписку и звонки": "Connect channels to bring messaging and calls together",
  "Общайтесь с клиентами в WhatsApp, Messenger, Telegram и TikTok — все каналы собираются в Hub в единой ленте входящих.":
    "Talk to customers on WhatsApp, Messenger, Telegram and TikTok — all channels come together in one Hub inbox.",
  "WhatsApp по QR-коду, Telegram по токену": "WhatsApp via QR code, Telegram via token",
  "Почта и звонки в том же окне": "Email and calls in the same window",
  "Узнайте, как жизненный цикл превращает потенциальных покупателей в клиентов": "Learn how the lifecycle turns prospects into customers",
  "Воронка показывает, на каком этапе продаж находится каждый контакт: этапы перетаскиваются, а стартовый и выигранный назначаются в один клик.":
    "The pipeline shows which sales stage each contact is at: drag stages around and set the start and won stages in one click.",
  "Открыть жизненный цикл": "Open lifecycle",
  "Этапы под ваш процесс продаж": "Stages tailored to your sales process",
  "Воронка и таблица строятся сами": "Pipeline and table build themselves",
  "Настройте AI-агентов, чтобы разгрузить команду": "Set up AI agents to take load off the team",
  "AI Assist читает шаблоны и источники знаний компании и предлагает готовый ответ. Персону можно переписать под тон бренда и сразу проверить в тесте.":
    "AI Assist reads your snippets and knowledge sources and suggests a ready reply. Rewrite the persona to match your brand voice and test it right away.",
  "Настроить AI Assist": "Set up AI Assist",
  "Ответы по вашим документам": "Replies based on your documents",
  "Проверка черновика до отправки": "Review the draft before sending",
  "Пригласите коллег работать с диалогами вместе": "Invite colleagues to work on conversations together",
  "Добавьте сотрудников по почте и выберите уровень доступа: агент видит свои диалоги, менеджер — все, администратор настраивает номера и ключи.":
    "Add teammates by email and choose an access level: an agent sees their own conversations, a manager sees all, an admin configures numbers and keys.",
  "Пригласить коллег": "Invite colleagues",
  "Приглашение приходит письмом": "The invitation arrives by email",
  "Права задаются при добавлении": "Permissions are set when adding",
  "Смотреть вводное видео по входящим": "Watch the inbox intro video",
  "Связаться с поддержкой": "Contact support",
  "Забронировать демо": "Book a demo",
  "Справочный центр": "Help centre",
  "Видеоинструкции": "Video guides",
  "Четыре шага до работы": "Four steps to get going",
  "Пройдите чеклист один раз — и входящие, воронка и ассистент будут готовы к бою.": "Go through the checklist once — and the inbox, pipeline and assistant are ready for action.",
  "Прогресс считается сам": "Progress is tracked automatically",
  "Отметьте шаг выполненным — полоса прогресса и счётчик обновятся сразу.": "Mark a step as done — the progress bar and counter update instantly.",
  "Всегда есть куда обратиться": "Help is always at hand",
  "Справа — ресурсы: вводное видео, поддержка, демо и справочный центр.": "On the right — resources: intro video, support, demo and help centre.",

  // ── отчёты: даты ──
  "января": "January",
  "февраля": "February",
  "марта": "March",
  "апреля": "April",
  "мая": "May",
  "июня": "June",
  "июля": "July",
  "августа": "August",
  "сентября": "September",
  "октября": "October",
  "ноября": "November",
  "декабря": "December",
  "янв": "Jan",
  "фев": "Feb",
  "мар": "Mar",
  "апр": "Apr",
  "июн": "Jun",
  "июл": "Jul",
  "авг": "Aug",
  "сен": "Sep",
  "окт": "Oct",
  "ноя": "Nov",
  "дек": "Dec",
  "{day} {month} {year} г.": "{day} {month} {year}",

  // ── отчёты ──
  "Отчёт «{report}» пересчитан за выбранный период": "Report \"{report}\" recalculated for the selected period",
  "Открыт отчёт «{report}»": "Opened report \"{report}\"",
  "Демо-данные включены: в отчёте появились события за период": "Demo data on: the report now has events for the period",
  "Демо-данные выключены — цифры снова нулевые": "Demo data off — numbers are back to zero",
  "рабочее пространство → отчеты": "workspace → reports",
  "Отчёт за {n} дней": "Report for {n} days",
  "{n} фильтр(а)": "{n} filter(s)",
  "без фильтров": "no filters",
  "с фильтрами": "with filters",
  "{n} дней": "{n} days",
  "Последнее обновление": "Last updated",
  "Обновить отчёт": "Refresh report",
  "Период: {range}": "Period: {range}",
  "Убрать фильтр {value}": "Remove filter {value}",
  "Добавить фильтр": "Add filter",
  "Все фильтры сняты": "All filters cleared",
  "Очистить все": "Clear all",
  "Включить демо-данные": "Turn on demo data",
  "Ещё действия с отчётом": "More report actions",
  "Скачать CSV": "Download CSV",
  "Скопировать ссылку": "Copy link",
  "Настроить отчёт": "Configure report",
  "«{label}» в демо-режиме недоступен": "\"{label}\" is not available in demo mode",
  "Учитывается время доставки": "Based on delivery time",
  "Группа": "Group",
  "Доля": "Share",
  "Всего": "Total",
  "Демо-режим: цифры пересчитываются только на этой странице и не сохраняются после перезагрузки.":
    "Demo mode: numbers are recalculated only on this page and are not saved after reload.",
  "Европа/Рим (GMT+01:00)": "Europe/Rome (GMT+01:00)",
  "Цифры считаются по событиям за выбранный период времени. Если фильтры не находят ни одного события, график остаётся пустым.":
    "Numbers are based on events in the selected period. If the filters match no events, the chart stays empty.",
  "Выбранный(ы) фильтр(ы) не содержит(ют) подходящих данных.": "The selected filter(s) contain no matching data.",
  "Данных за выбранный период нет — включите демо-данные в шапке окна.": "No data for the selected period — turn on demo data in the window header.",
  "Последние 7 дней": "Last 7 days",
  "Последние 14 дней": "Last 14 days",
  "Последние 30 дней": "Last 30 days",
  "Этот месяц": "This month",
  "Виджет": "Widget",
  "Завершено": "Completed",
  "Ошибка": "Error",
  "В процессе": "In progress",
  "Продажи": "Sales",
  "Поддержка": "Support",
  "Администраторы": "Admins",
  "Период считается по доставке": "Period is based on delivery",
  "Событие попадает в отчёт по времени доставки, а не создания. Поэтому смена периода может сдвинуть цифры на границе дней.":
    "An event enters the report by delivery time, not creation time. Changing the period may therefore shift numbers at day boundaries.",
  "Фильтры сужают выборку": "Filters narrow the sample",
  "Каждый добавленный фильтр отсекает часть событий. Три фильтра сразу могут дать пустой результат — это нормально, снимите один чип.":
    "Each added filter cuts off part of the events. Three filters at once may give an empty result — that's normal, remove one chip.",
  "Отчёт можно выгрузить": "Reports can be exported",
  "В демо-режиме выгрузка недоступна, но в рабочем пространстве любой отчёт сохраняется в CSV вместе с применёнными фильтрами.":
    "Export is unavailable in demo mode, but in the workspace any report can be saved to CSV together with the applied filters.",
  "Отчёт показывает, как контакты двигаются по этапам воронки: сколько появилось, дошло до сделки и потерялось за выбранный период. Считается по истории смены этапов.":
    "Shows how contacts move through pipeline stages: how many appeared, reached a deal and were lost in the selected period. Based on stage change history.",
  "Обзор этапов": "Stages overview",
  "Результаты по этапам": "Results by stage",
  "Продвинулись": "Advanced",
  "Потеряны": "Lost",
  "Контактов продвинулось": "Contacts advanced",
  "Контактов потеряно": "Contacts lost",
  "Новые лиды": "New leads",
  "Квалифицированы": "Qualified",
  "Сделка": "Deal",
  "Выиграно": "Won",
  "Отчёт по входящим, исходящим и внутренним звонкам: длительность, принятые и пропущенные вызовы. Помогает увидеть часы, когда команда не успевает отвечать.":
    "Report on inbound, outbound and internal calls: duration, answered and missed calls. Helps spot the hours when the team cannot keep up.",
  "Обзор звонков": "Calls overview",
  "Результаты по типам звонков": "Results by call type",
  "Принятые": "Answered",
  "Пропущенные": "Missed",
  "Звонки приняты": "Calls answered",
  "Звонки пропущены": "Calls missed",
  "Исходящие": "Outbound",
  "Внутренние": "Internal",
  "Обратные звонки": "Callbacks",
  "Беседы": "Conversations",
  "Отчёт по диалогам: сколько открыто, закрыто и осталось без ответа. Разбивка по каналам показывает, откуда приходит больше всего обращений.":
    "Report on conversations: how many were opened, closed and left unanswered. The channel breakdown shows where most enquiries come from.",
  "Обзор бесед": "Conversations overview",
  "Результаты по каналам": "Results by channel",
  "Закрытые": "Closed",
  "Беседы закрыты": "Conversations closed",
  "Беседы открыты": "Conversations open",
  "Виджет на сайте": "Website widget",
  "Ответы": "Replies",
  "Отчёт о скорости первого ответа: сколько диалогов закрыто в SLA, сколько просрочено и сколько осталось без ответа вовсе.":
    "Report on first reply speed: how many conversations were closed within SLA, how many were overdue and how many got no reply at all.",
  "Обзор ответов": "Replies overview",
  "Результаты по времени ответа": "Results by reply time",
  "В срок": "On time",
  "Ответы в SLA": "Replies within SLA",
  "Ответы просрочены": "Replies overdue",
  "До 5 минут": "Under 5 minutes",
  "До 30 минут": "Under 30 minutes",
  "До 2 часов": "Under 2 hours",
  "Без ответа": "No reply",
  "Резолюции": "Resolutions",
  "Отчёт по закрытию диалогов: кто закрыл беседу — AI-агент, продавец или поддержка — и сколько диалогов пришлось эскалировать людям.":
    "Report on closing conversations: who closed them — an AI agent, a sales rep or support — and how many had to be escalated to people.",
  "Обзор резолюций": "Resolutions overview",
  "Результаты по исполнителям": "Results by resolver",
  "Решено": "Resolved",
  "Эскалировано": "Escalated",
  "Диалогов решено": "Conversations resolved",
  "Эскалировано людям": "Escalated to people",
  "Продавцы": "Sales reps",
  "Руководители": "Managers",
  "Сообщения": "Messages",
  "Отчёт по объёму переписки: сколько сообщений ушло клиентам и сколько пришло. Разбивка по каналам помогает планировать нагрузку на смену.":
    "Report on messaging volume: how many messages were sent to customers and how many came in. The channel breakdown helps plan shift workload.",
  "Обзор сообщений": "Messages overview",
  "Сообщений отправлено": "Messages sent",
  "Сообщений получено": "Messages received",
  "Отчёт по базе клиентов: откуда появились новые контакты, сколько записей обновили вручную и сколько удалили или объединили как дубли.":
    "Report on the customer base: where new contacts came from, how many records were updated manually and how many were deleted or merged as duplicates.",
  "Обзор контактов": "Contacts overview",
  "Результаты по источникам": "Results by source",
  "Созданы": "Created",
  "Удалены": "Deleted",
  "Контактов создано": "Contacts created",
  "Контактов удалено": "Contacts deleted",
  "Из диалогов": "From conversations",
  "Импорт CSV": "CSV import",
  "Вручную": "Manually",
  "Интеграции": "Integrations",
  "Задания": "Tasks",
  "Отчёт по задачам команды: сколько заданий закрыто в срок, сколько просрочено и какие типы заданий чаще всего зависают.":
    "Report on team tasks: how many were closed on time, how many are overdue and which task types stall most often.",
  "Обзор заданий": "Tasks overview",
  "Результаты по типам заданий": "Results by task type",
  "Выполнены": "Completed",
  "Просрочены": "Overdue",
  "Задания выполнены": "Tasks completed",
  "Задания просрочены": "Tasks overdue",
  "Письма": "Emails",
  "Встречи": "Meetings",
  "Проверки": "Checks",
  "Таблица лидеров": "Leaderboard",
  "Рейтинг сотрудников по закрытым диалогам и соблюдению SLA. Цифры считаются по событиям выбранного периода, а не по общему стажу.":
    "Ranking of team members by closed conversations and SLA compliance. Based on events in the selected period, not overall tenure.",
  "Обзор рейтинга": "Ranking overview",
  "Результаты по сотрудникам": "Results by team member",
  "Диалогов закрыто в срок": "Conversations closed on time",
  "Диалогов просрочено": "Conversations overdue",
  "Лев Орлов": "Lev Orlov",
  "Мира Соколова": "Mira Sokolova",
  "Пользователи": "Users",
  "Отчёт по участникам рабочего пространства: кто был активен, кто не заходил в систему и кому ограничили доступ.":
    "Report on workspace members: who was active, who has not signed in and whose access was restricted.",
  "Обзор пользователей": "Users overview",
  "Результаты по ролям": "Results by role",
  "Активные": "Active",
  "Неактивные": "Inactive",
  "Активных пользователей": "Active users",
  "Без активности": "No activity",
  "Менеджеры": "Managers",
  "Агенты": "Agents",
  "Наблюдатели": "Viewers",
  "Трансляции": "Broadcasts",
  "Этот отчёт поможет получить представление о результатах трансляции. В отчете учитываются только трансляции, отправленные за выбранный период времени на основе времени доставки. Узнайте больше":
    "This report gives an overview of broadcast results. Only broadcasts sent in the selected period, based on delivery time, are included. Learn more",
  "Обзор трансляций": "Broadcasts overview",
  "Завершенный": "Completed",
  "Неуспешный": "Failed",
  "Трансляции завершены": "Broadcasts completed",
  "Трансляции провалены": "Broadcasts failed",
};
export default d;
